// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1xu2C","infoBtn":"quickbooks_infoBtn__1UDPQ","formBox":"quickbooks_formBox__2bq65","formFooter":"quickbooks_formFooter__1i3GJ"};